function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["tagName", "className", "style", "children", "allowMouseEvents", "onSwipeUp", "onSwipeDown", "onSwipeLeft", "onSwipeRight", "onSwipeStart", "onSwipeMove", "onSwipeEnd", "innerRef", "tolerance"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
var supportsCaptureOption = false;
export function setHasSupportToCaptureOption(hasSupport) {
  supportsCaptureOption = hasSupport;
}
try {
  addEventListener('test', null, Object.defineProperty({}, 'capture', {
    get: function get() {
      setHasSupportToCaptureOption(true);
    }
  }));
} catch (e) {}
function getSafeEventHandlerOpts() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    capture: true
  };
  return supportsCaptureOption ? options : options.capture;
}
function getPosition(event) {
  if ('touches' in event) {
    var _event$touches$ = event.touches[0],
      pageX = _event$touches$.pageX,
      pageY = _event$touches$.pageY;
    return {
      x: pageX,
      y: pageY
    };
  }
  var screenX = event.screenX,
    screenY = event.screenY;
  return {
    x: screenX,
    y: screenY
  };
}
var ReactSwipe = function (_Component) {
  _inherits(ReactSwipe, _Component);
  var _super = _createSuper(ReactSwipe);
  function ReactSwipe() {
    var _this;
    _classCallCheck(this, ReactSwipe);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this._handleSwipeStart = _this._handleSwipeStart.bind(_assertThisInitialized(_this));
    _this._handleSwipeMove = _this._handleSwipeMove.bind(_assertThisInitialized(_this));
    _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_assertThisInitialized(_this));
    _this._onMouseDown = _this._onMouseDown.bind(_assertThisInitialized(_this));
    _this._onMouseMove = _this._onMouseMove.bind(_assertThisInitialized(_this));
    _this._onMouseUp = _this._onMouseUp.bind(_assertThisInitialized(_this));
    _this._setSwiperRef = _this._setSwiperRef.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ReactSwipe, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.swiper) {
        this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
          capture: true,
          passive: false
        }));
      }
    }
  }, {
    key: "_onMouseDown",
    value: function _onMouseDown(event) {
      if (!this.props.allowMouseEvents) {
        return;
      }
      this.mouseDown = true;
      document.addEventListener('mouseup', this._onMouseUp);
      document.addEventListener('mousemove', this._onMouseMove);
      this._handleSwipeStart(event);
    }
  }, {
    key: "_onMouseMove",
    value: function _onMouseMove(event) {
      if (!this.mouseDown) {
        return;
      }
      this._handleSwipeMove(event);
    }
  }, {
    key: "_onMouseUp",
    value: function _onMouseUp(event) {
      this.mouseDown = false;
      document.removeEventListener('mouseup', this._onMouseUp);
      document.removeEventListener('mousemove', this._onMouseMove);
      this._handleSwipeEnd(event);
    }
  }, {
    key: "_handleSwipeStart",
    value: function _handleSwipeStart(event) {
      var _getPosition = getPosition(event),
        x = _getPosition.x,
        y = _getPosition.y;
      this.moveStart = {
        x: x,
        y: y
      };
      this.props.onSwipeStart(event);
    }
  }, {
    key: "_handleSwipeMove",
    value: function _handleSwipeMove(event) {
      if (!this.moveStart) {
        return;
      }
      var _getPosition2 = getPosition(event),
        x = _getPosition2.x,
        y = _getPosition2.y;
      var deltaX = x - this.moveStart.x;
      var deltaY = y - this.moveStart.y;
      this.moving = true;
      var shouldPreventDefault = this.props.onSwipeMove({
        x: deltaX,
        y: deltaY
      }, event);
      if (shouldPreventDefault) {
        event.preventDefault();
      }
      this.movePosition = {
        deltaX: deltaX,
        deltaY: deltaY
      };
    }
  }, {
    key: "_handleSwipeEnd",
    value: function _handleSwipeEnd(event) {
      this.props.onSwipeEnd(event);
      var tolerance = this.props.tolerance;
      if (this.moving && this.movePosition) {
        if (this.movePosition.deltaX < -tolerance) {
          this.props.onSwipeLeft(1, event);
        } else if (this.movePosition.deltaX > tolerance) {
          this.props.onSwipeRight(1, event);
        }
        if (this.movePosition.deltaY < -tolerance) {
          this.props.onSwipeUp(1, event);
        } else if (this.movePosition.deltaY > tolerance) {
          this.props.onSwipeDown(1, event);
        }
      }
      this.moveStart = null;
      this.moving = false;
      this.movePosition = null;
    }
  }, {
    key: "_setSwiperRef",
    value: function _setSwiperRef(node) {
      this.swiper = node;
      this.props.innerRef(node);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        tagName = _this$props.tagName,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        allowMouseEvents = _this$props.allowMouseEvents,
        onSwipeUp = _this$props.onSwipeUp,
        onSwipeDown = _this$props.onSwipeDown,
        onSwipeLeft = _this$props.onSwipeLeft,
        onSwipeRight = _this$props.onSwipeRight,
        onSwipeStart = _this$props.onSwipeStart,
        onSwipeMove = _this$props.onSwipeMove,
        onSwipeEnd = _this$props.onSwipeEnd,
        innerRef = _this$props.innerRef,
        tolerance = _this$props.tolerance,
        props = _objectWithoutProperties(_this$props, _excluded);
      return React.createElement(this.props.tagName, _extends({
        ref: this._setSwiperRef,
        onMouseDown: this._onMouseDown,
        onTouchStart: this._handleSwipeStart,
        onTouchEnd: this._handleSwipeEnd,
        className: className,
        style: style
      }, props), children);
    }
  }]);
  return ReactSwipe;
}(Component);
_defineProperty(ReactSwipe, "displayName", 'ReactSwipe');
_defineProperty(ReactSwipe, "propTypes", {
  tagName: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  allowMouseEvents: PropTypes.bool,
  onSwipeUp: PropTypes.func,
  onSwipeDown: PropTypes.func,
  onSwipeLeft: PropTypes.func,
  onSwipeRight: PropTypes.func,
  onSwipeStart: PropTypes.func,
  onSwipeMove: PropTypes.func,
  onSwipeEnd: PropTypes.func,
  innerRef: PropTypes.func,
  tolerance: PropTypes.number.isRequired
});
_defineProperty(ReactSwipe, "defaultProps", {
  tagName: 'div',
  allowMouseEvents: false,
  onSwipeUp: function onSwipeUp() {},
  onSwipeDown: function onSwipeDown() {},
  onSwipeLeft: function onSwipeLeft() {},
  onSwipeRight: function onSwipeRight() {},
  onSwipeStart: function onSwipeStart() {},
  onSwipeMove: function onSwipeMove() {},
  onSwipeEnd: function onSwipeEnd() {},
  innerRef: function innerRef() {},
  tolerance: 0
});
export { ReactSwipe as Swipe };